const Form069EN = {
    stepName: {
        statement: "Statement",
        information: "Basic Information",
        certification: "Section D\nCertification",
        confirmation: "Confirmation",
        schoolInfo: "School Information",
        SelectApplyType: "Selection of Section(s)",
        sectionA:
            "Section A\nTemporary freezing of teaching vacant posts arising from teachers on leave",
        sectionB:
            "Section B\nTemporary freezing of teaching posts on the approved establishment",
        sectionC: "Section C\nPermanent freezing of regular posts",
    },
    title: {
        note: "Note",
        schoolInformation: "School Information",
        secitonATitle:
            "Section A	 Temporary Freezing of Teaching Vacant Posts Arising from Teachers on Leave",
        secitonBTitle:
            "Section B	 Temporary Freezing of Teaching Posts on the Approved Establishment",
        secitonCTitle: "Section C	 Permanent Freezing of Regular Posts",
        secitonCTitleB: "Section C	 Permanent Freezing of Regular Posts",
        secitonDTitle: "Section D    Certification",
        teachersInformation: "Information of Teachers on Leave",
        calculationInformation: "Information on TRG Calculation",
        officialUse: "Official Use",
        collectionStatement: "Personal Information Collection Statement",
    },
    label: {
        absenceReasonOption: {
            optionA: "(a)	Paid Sick/Maternity/Special Tuberculosis Leave",
            optionB: "(b)	Paid Study Leave",
            optionC: "(c)	Paid Leave for Teachers for Juror or Witness Service",
            optionD: "(d)	Other Paid Leave (Please Specify The Reason)",
            optionF: "(x)	No-pay Sick/Maternity/Special Tuberculosis Leave",
            optionG: "(y)	Other no-pay leave",
        },
        leaveCalendarDaysOption: {
            thirty: "Leave of 30 to 89 Calendar Days",
            ninety: "Leave of 90 Calendar Days or More",
        },
        vacancyCalendarDaysOption: {
            thirty: "Vacancy of 30 to 89 Calendar Days",
            ninety: "Vacancy of 90 Calendar Days or More",
        },
        NAMOption: {
            N: "New claim posts",
            AM: "Amendment of previous claim",
        },
        PRENEWOption: {
            PRE: "PRE",
            NEW: "NEW",
        },
        surplusTeachersOption: {
            yes: "has",
            no: "has no",
        },
        schoolName: "Name of School",
        schoolCode: "School Code",
        name: "Name",
        SRN: "SRN",
        post: "Post",
        postNumber: "Number of Posts",
        absenceReason: "Reason for absence",
        paidLeaveReason: "Reason for Other Paid Leave",
        leavePeriodFrom: "Leave Period From",
        leavePeriodTo: "Leave Period To",
        periodFrom: "Period From",
        periodTo: "Period To",
        workingDays: "(a) No. of Working Days",
        dailyRate: "(b) Daily Rate $",
        monthsNo: "(c) No. of Months",
        monthlySalary: "(d) Monthly Salary $",
        MPFSubsidy: "(e) MPF Subsidy $",
        TRGAmount: "(f) TRG Amount",
        TRGTotalAmount: "TRG Amount $(Total)",
        postsClaimedNo: "No. of Posts Claimed",
        postsClaimedNoSectionC: "(a) No. of Posts Claimed",
        rank: "Rank",
        NAM: "N: New claim posts / AM: Amendment of previous claim (copy attached).",
        attachment: "Attachment",
        PRENEW: "PRE/NEW",
        Date: "Date of the previous claim",
        effectiveDate: "Effective Date",
        monthlyEffectiveDate:
            "(a) Monthly Mid-point Salary at the Effective Date $ (for NEW Frozen Posts Only)",
        frozenMPFSubsidy: "(b) MPF Subsidy $ (for NEW Frozen Posts Only)",
        frozenTRGAmount: "(c) TRG Amount for Newly Frozen Posts $",
        frozenPostsTotal: "Total Number of Frozen Posts",
        frozenPostsArising: "The Temporary Frozen Posts Arising",
        approvedTeaching: "The Teaching Posts on the Approved Establishment",
        frozenRegularPosts: "The Permanent Frozen Regular Posts",
        total: "Total",
        surplusTeachers: "Surplus Teachers",
        surplusTeachersNo: "No. of Surplus Teachers",
        contactPerson: "Contact Person",
        telNo: "Tel No.",
        SSDO: "SSDO",
        required: "Required",
        select: "Please select the section(s) you want to apply:",
        supervisorName: "Name of Supervisor/School Head",
        mpfAttachment: "Attachment for MPF Schemes",
        termsConditions:
            "I have read the “Personal Information Collection Statement” and fully understand its content.",
        iamStatement:
            "I understand that an “iAM Smart+” account is required for processing the application.",
    },
    message: {
        toMessage: "To: Recurrent Subventions Section, Education Bureau",
        attnMessage: "[Attn.:  AOI(RS)]",
    },
    note: {
        importantNote1:
            "PLEASE READ THE FOLLOWING TERMS AND CONDITIONS BEFORE USING THIS WEBSITE. BY USING THIS WEBSITE YOU AGREE TO ABIDE BY THE TERMS AND CONDITIONS SET OUT BELOW",
        importantNote2:
            "please submit either e-form or paper, if duplicate application has been submitted, the process would be decelerated.",
        importantNote3:
            "Enquiries concerning the personal data collected by means of this form, including making of access and corrections,should be made in writing to the respective Senior School Development Officer.",
        note1: "1.	 Enter Staff Reference Number of teachers on leave.",
        note2: "2.	 Enter the alphabet from the list of reasons for absence below-",
        note3: "(a) paid sick/maternity/special tuberculosis leave;",
        note4: "(b) paid study leave;",
        note5: "(c) paid leave for teachers for juror or witness service;",
        note6: "(d) other paid leave(Please specify the reason);",
        note7: "(x) no-pay sick/maternity/special tuberculosis leave;",
        note8: "(y) other no-pay leave.",
        note9: "Please note that schools are required to follow EDB Circular No.1/2006 and No.16/2018 when granting leave.",
        note10: "3.	 The number of working days should exclude Sunday, Saturday(short-week), public holidays, discretionary holidays or any days on which the teachers are not required to perform duties.",
        note11: "4.	 Please refer to the relevant EDB circular memorandum on the prevailing daily rates of pay for supply teachers in aided schools. As for the actual amount of the standard daily rates of supply teachers and various rates for freezing, they are adjusted in accordance with the civil service pay adjustment.",
        note12: "5.	 Use the average monthly salary point of temporary teachers for basic ranks or starting salary point for promotion ranks. The average monthly salary points for the purposes of calculating the optional cash grant will be reviewed every 3 years and revised if necessary. For the average monthly salary points of respective ranks, please refer to the TRG guidelines at EDB homepage at ",
        note12b:
            "http://www.edb.gov.hk/en/sch-admin/fin-management/subsidy-info/trg/index.html",
        note12c: ".",
        note13: "6.	 For freezing of a vacant teaching post of 60 calendar days or more, employer’s contributions to MPF Scheme(5% of the monthly salary or $1,500, whichever is the less) will be included.",
        note14: "7.	 The teaching posts for freezing exclude the post for principal/head teacher, Native-speaking English Teacher, Student Guidance Teacher, Primary School Curriculum Leader, Special Educational Needs Coordinator and Special Educational Needs Support Teacher.",
        certificationNote1: "I certify that * –",
        certificationNote2:
            "consent has been obtained from my school’s IMC for freezing the above teaching post(s) in the above-mentioned period in the school year;",
        certificationNote3:
            "no salaries grant of teachers filling the vacant posts as mentioned in Section B and C above have been claimed;",
        certificationNote4: {
            note1: "the total number of frozen posts",
            note2: "claiming TRG including the temporary frozen posts arising from (Section A) teachers on leave",
            note3: "and (Section B) the teaching posts on the approved establishment",
            note4: "together with (Section C) the permanent frozen regular posts",
            note5: "does not exceed the ceiling of 10% of the approved teaching staff establishment of my school (Total:",
            note6: ") at the claim date",
            note7: " and ",
            note8: "this request for payment complies with all the conditions set out for TRG applications",
            note9: "  (Please enter number of posts in the space provided);",
        },
        certificationNote5: {
            note1: "the school ",
            note2: "* surplus teachers and the number of surplus teachers has been offset before temporarily freezing teaching vacant posts arising from teachers on leave;",
            note3: "* surplus teachers and the number of surplus teachers has been offset before temporarily freezing teaching vacant posts arising from teachers on leave;",
        },
        certificationNote6:
            "no duplicate claim has been made for government subventions on account of the same leave/vacancy/frozen period set out above, such as the encashment of Additional Teaching Posts for English and the fractional staff entitlement for claiming Fractional Post Cash Grant; and",
        certificationNote7:
            "except the surplus teacher situation mentioned in (iv) above, the sum of the total number of the frozen posts and the strength of my school would not exceed the approved teaching staff establishment at any point in time.",
        certificationNote8:
            "My school will refund to the Education Bureau any over-payment of grant.",
        statementNote: {
            note1: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s): ",
            note2: "(a) processing employment-related matters;",
            note3: "(b) processing payment of Salaries Grant and other government funding;",
            note4: "(c) calculation of provident fund contribution;",
            note5: "(d) auditing;",
            note6: "(e) conducting research and compiling statistics to facilitate planning of education services;",
            note7: "(f) processing matters relating to the development of the education profession;",
            note8: "(g) administering and enforcing stipulations under the relevant Code of Aid, Education Ordinance, Education Regulations and the Grant/Subsidized Schools Provident Fund Rules.",
            note9: "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
            note10: "The personal data collected in this form may be disclosed to other government bureaux/departments/agencies authorized to process such information for the purposes mentioned above.",
            note11: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee.",
            note12: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to the respective Senior School Development Officer.",
        },
    },
    order: ["(i)", "(ii)", "(iii)", "(iv)", "(v)", "(vi)"],
    tooltip: {
        tooltip1: "Enter Staff Reference Number of teachers on leave.",
        tooltip2:
            "Please note that schools are required to follow EDB Circular No.1/2006 and No.16/2018 when granting leave.",
        tooltip3:
            "The number of working days should exclude Sunday, Saturday(short-week), public holidays, discretionary holidays or any days on which the teachers are not required to perform duties.",
        tooltip4:
            "Please refer to the relevant EDB circular memorandum on the prevailing daily rates of pay for supply teachers in aided schools. As for the actual amount of the standard daily rates of supply teachers and various rates for freezing, they are adjusted in accordance with the civil service pay adjustment.",
        tooltip5a:
            "Use the average monthly salary point of temporary teachers for basic ranks or starting salary point for promotion ranks. The average monthly salary points for the purposes of calculating the optional cash grant will be reviewed every 3 years and revised if necessary. For the average monthly salary points of respective ranks, please refer to the TRG guidelines at EDB homepage at ",
        tooltip5b:
            "http://www.edb.gov.hk/en/sch-admin/fin-management/subsidy-info/trg/index.html",
        tooltip5c: ".",
        tooltip6:
            "For freezing of a vacant teaching post of 60 calendar days or more, employer’s contributions to MPF Scheme(5% of the monthly salary or $1,500, whichever is the less) will be included.",
        tooltip7:
            "The teaching posts for freezing exclude the post for principal/head teacher, Native-speaking English Teacher, Student Guidance Teacher, Primary School Curriculum Leader, Special Educational Needs Coordinator and Special Educational Needs Support Teacher.",
        tooltipCTitle:
            "All first time frozen posts and previously frozen posts should be included in this claim form for the purpose of checking of the 10% ceiling",
        tooltipC1: "PRE: Posts previously frozen / NEW: New frozen posts ",
        tooltipC2:
            "For freezing of vacant posts of 60 days or more, employer’s contributions to MPF Scheme (5 % of the monthly salary or $1,500, whichever is the less) will be included.",
    },
    SSDOValue: {
        0: "North District",
        1: "Kwai Chung & Tsing Yi District",
        2: "Sai Kung District",
        3: "Hong Kong East District",
        4: "Tuen Mun District",
        5: "Kowloon City District",
        6: "Kwun Tong District",
        7: "Southern District",
        8: "Yau Tsim & Mong Kok District",
        9: "Tsuen Wan District",
        10: "Sha Tin District",
        11: "Sham Shui Po District",
        12: "Tai Po District",
        13: "Wan Chai District",
        14: "Islands District",
        15: "Central & Western District",
        16: "Yuen Long District",
        17: "Wong Tai Sin District",
    },
    errorMsg: {
        least30Days:
            "The period is below 30 calendar days, please choose again",
        "E-001":
            "Only english character, sapce( ), dot(.), comma(,), hyphen(-) and single quote(') is allowed.",
        "E-002": "Please select at least 1 item",
    },
};
export default Form069EN;
